import {ChangeDetectorRef, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Meeting} from '../../../forms/modules/sp/models/spMeeting';


@Pipe({
  name: 'filterSearchSpMeeting'
})
export class FilterSearchSpMeetingPipe implements PipeTransform {
  constructor(private cdr: ChangeDetectorRef, private translate: TranslateService) {
  }

  transform(items: Meeting[], searchText: string, meetingsFilterMetadata): Meeting[] {
    if (!items) {
      meetingsFilterMetadata.count = 0;
      this.cdr.detectChanges();
      return [];
    }
    if (!searchText) {
      meetingsFilterMetadata.count = items.length;
      this.cdr.detectChanges();
      return items;
    }
    searchText = searchText.toLowerCase();

    const filteredItems = items.filter((meetings: Meeting) => {
      let text = new Date(meetings.meetingDate).toLocaleDateString().replace(/\s/g, '') + ' ' + meetings.title + ', ';
      text += meetings.attachment ? meetings.attachment.name : 'Bez prílohy';
      return text.toLowerCase().indexOf(searchText) !== -1;
    });
    meetingsFilterMetadata.count = filteredItems.length;
    this.cdr.detectChanges();
    return filteredItems;
  }

}
